export default __webpack_public_path__ + "static/travel-bee-75866fbaef1f46dc1f7e941e3fb8711a.png";